import { RECHARGE_FEATURE, type RechargeFeature } from '@flux/shared';
import { ExternalLink } from 'lucide-react';
import type { JSX } from 'react';
import { rechargeAdminObjectUrl } from './recharge-links.js';

/**
 * Objet Recharge cité par un webhook (`{type} {id}`), avec le lien vers
 * l'admin Recharge quand il existe. Le clic sur le lien ne remonte pas à la
 * ligne du tableau (qui ouvrirait le panneau).
 */
export function WebhookObject({
  objectType,
  objectId,
}: {
  objectType: string | null;
  objectId: string | null;
}): JSX.Element {
  if (objectType === null && objectId === null) {
    return <span className="text-muted-foreground">—</span>;
  }
  const label = [objectType, objectId].filter((part) => part !== null).join(' ');
  const href = rechargeAdminObjectUrl(objectType, objectId);
  if (href === null) {
    return (
      <span className="whitespace-nowrap font-mono text-xs tabular-nums" translate="no">
        {label}
      </span>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      translate="no"
      aria-label={`Ouvrir ${label} dans Recharge`}
      onClick={(event) => {
        event.stopPropagation();
      }}
      onKeyDown={(event) => {
        event.stopPropagation();
      }}
      className="inline-flex items-center gap-1 whitespace-nowrap rounded-sm font-mono text-xs tabular-nums text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      {label}
      <ExternalLink className="size-3.5" aria-hidden="true" />
    </a>
  );
}

/** Libellé de la fonction Recharge qui a traité le webhook, « — » si aucune. */
export function WebhookFeature({ feature }: { feature: RechargeFeature | null }): JSX.Element {
  return feature === null ? (
    <span className="text-muted-foreground">—</span>
  ) : (
    <span>{RECHARGE_FEATURE[feature].label}</span>
  );
}
